import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import supabase from 'modules/core/supabase/supabase';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { UDText } from 'ud-ui/components';
import Modal from 'ud-ui/components/modal';
import MediaManagerTemplateForm, {
  MediaManagerTemplateFormValues,
} from '../../components/forms/media-manager-template-form';

interface Args {
  existingNames: string[];
  onCreated: () => void;
}

function useCreateTemplateModal({ existingNames, onCreated }: Args) {
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { info } = useOrganizer();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const onSubmit = useCallback(
    async (values: MediaManagerTemplateFormValues) => {
      if (!tournamentId) return;
      setIsLoading(true);
      try {
        await supabase.mediaManager.createTemplate({
          name: values.name.trim(),
          tournamentId,
          sportType: info?.sportType ?? null,
        });
        onCreated();
        close();
      } catch (error) {
        console.error('Failed to create media manager template:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [tournamentId, info, onCreated, close],
  );

  return {
    open,
    close,
    modal: (
      <Modal show={isOpen} onClose={close}>
        <UDText type="title-3" className="mb-5">
          Создать шаблон
        </UDText>
        <MediaManagerTemplateForm
          initialValues={{ name: '' }}
          existingNames={existingNames}
          isLoading={isLoading}
          onSubmit={onSubmit}
        />
      </Modal>
    ),
  };
}

export default useCreateTemplateModal;
